export function selectSessionUserId(state) {
    return state.session.user ? state.session.user.id : null;
}

export function isSessionUserPlatformAdmin(state) {
    return state.session.user ? state.session.user.is_platform_admin : false;
}